export default __webpack_public_path__ + "static/media/i_bus-noti.b8a63740.svg";